import markApplyRecordReducer from "./markApplyRecordReducer";

const cropMarkApplyRecordReducer = {
    cropMarkApplyRecords: markApplyRecordReducer
}

export default cropMarkApplyRecordReducer